<template>
  <div class="header-bar" :class="{ 'header-hidden': isHidden }">
    <div class="header-avatar">
      <img v-if="userImage" :src="userImage" alt="user" @error="handleImageError"/>
      <div v-else class="header-avatar-placeholder">
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </div>
    </div>

    <div class="header-title text-center">{{$route.meta.name}}</div>

    <button class="back-btn-circle cursor-pointer" v-on:click="$router.go(-1)" v-if='$route.meta.name != "خانه"'>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18l-6-6 6-6" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
  
</template>

<script>
export default {
  data() {
    return { lastScrollY: 0, isHidden: false, scroller: null, userImage: '' }
  },
  mounted() {
    this.scroller = this.getScrollParent(this.$el) || window
    this.lastScrollY = this.getScrollTop()
    // Listen on window always
    window.addEventListener('scroll', this.onScroll, { passive: true })
    // Also listen on nearest scrollable container if different
    if (this.scroller && this.scroller !== window) {
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true })
    }
    this.userImage = this.get_user_image()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    if (this.scroller && this.scroller !== window) {
      this.scroller.removeEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    onScroll() {
      const current = this.getScrollTop()
      const delta = current - this.lastScrollY
      // hide when scrolling down more than a few px, show when scrolling up
      if (delta > 6 && current > 20) this.isHidden = true
      else if (delta < -6) this.isHidden = false
      this.lastScrollY = current
    },
    getScrollParent(el) {
      let node = el && el.parentElement
      while (node) {
        const style = window.getComputedStyle(node)
        if (/auto|scroll/i.test(style.overflowY)) return node
        node = node.parentElement
      }
      return window
    },
    getScrollTop() {
      const pageY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      if (!this.scroller || this.scroller === window) return pageY
      const localY = this.scroller.scrollTop || 0
      return Math.max(pageY, localY)
    },
    normalizeImageUrl(url) {
      if (!url || url === 'null' || url === 'undefined') return ''
      return url.startsWith('http') ? url : ('https://' + url)
    },
    get_user_image(){
      try {
        const tokenImage = this.normalizeImageUrl(localStorage.getItem('ImageUrl'))
        if (tokenImage) return tokenImage

        const profile = JSON.parse(localStorage.getItem('profile'))
        if (profile && profile.ThumbPath) {
          return this.normalizeImageUrl(profile.ThumbPath) || '/img/avatar.jpg'
        }
        return '/img/avatar.jpg'
      } catch(e) {
        return '/img/avatar.jpg'
      }
    },
    handleImageError(event) {
      // If the image fails to load, show the placeholder
      this.userImage = null
    }
  }
}
</script>

<style scoped>
.header-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff;
  padding: 15px 20px;
  position: sticky;
  top: 0;
  z-index: 1000;
  transition: transform .2s ease;
}
.header-hidden { transform: translateY(-100%); }
.header-modern {
  background: transparent !important;
  color: #111 !important;
  /* box-shadow: none !important; */
  padding: 8px 12px !important;
}
.back-btn-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.6);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #111;
}
.header-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid rgba(0,0,0,0.08);
}
.header-avatar img { width: 100%; height: 100%; object-fit: cover; }
.header-avatar-placeholder {
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
